import styled from 'styled-components';

const SpecialtiesContainer = styled.div`
  flex: 1;
  width: 100%;
`;

export { SpecialtiesContainer };
